import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../index';
import { TenantContext } from '../../context/tenant-context';
import { ItemGeneralLedgerAccountInput } from './item-general-ledger-account-input';
import { ProductGeneralLedgerAccount } from './product-general-ledger-account';
import { ToastContainer } from 'react-toastify';

export function initItemGeneralLedgerAccount(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('item-general-ledger-account');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ItemGeneralLedgerAccountInput {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}

export function initProductGeneralLedgerAccount(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('product-general-ledger-account');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ProductGeneralLedgerAccount {...props} product={parseInt(props.productId)} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
